import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelTransactionHistoryReport extends Layout {
    sourceFuelTransactionHistoryReport: DataSource;
    textboxDateRange: Textbox;
    textboxFuelInterfaceId: Textbox;
}
